<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="h-auto md:h-[80vh] rounded-2xl overflow-hidden mt-32 flex">
      <!-- Left Image -->
      <div
        class="hidden md:block md:w-1/2 bg-cover bg-center"
        style="
          background-image: url('./login.png');
        "
      ></div>

      <!-- Right Form -->
      <div
        class="flex flex-col justify-center md:w-1/2 px-5 md:py-0 py-5 md:px-16 bg-white"
      >
        <h2
          class="text-4xl font-extrabold mb-8"
          [style.color]="'var(--primary)'"
        >
          Sign Up
        </h2>
        <form
          (ngSubmit)="onSubmit()"
          [formGroup]="signUpForm"
          class="space-y-6 max-w-md w-full"
        >
          <input
            type="text"
            placeholder="Full Name"
            formControlName="fullName"
            name="fullName"
            required
            [class]="
              signUpForm.get('fullName')?.touched &&
              signUpForm.get('fullName')?.invalid
                ? 'focus:ring-2 focus:ring-red-600 border-red-300'
                : 'focus:ring-2 focus:ring-[var(--primary)] border-gray-300'
            "
            class="w-full px-4 py-3 rounded-xl border focus:outline-none"
          />

          <input
            type="email"
            placeholder="Email address"
            formControlName="email"
            name="email"
            [class]="
              signUpForm.get('email')?.touched &&
              signUpForm.get('email')?.invalid
                ? 'focus:ring-2 focus:ring-red-600 border-red-300'
                : 'focus:ring-2 focus:ring-[var(--primary)] border-gray-300'
            "
            required
            class="w-full px-4 py-3 rounded-xl border focus:outline-none"
          />

          <div class="relative w-full">
            <input
              [type]="hidePassword ? 'password' : 'text'"
              placeholder="Password"
              formControlName="password"
              name="password"
              [class]="
                signUpForm.get('password')?.touched &&
                signUpForm.get('password')?.invalid
                  ? 'focus:ring-2 focus:ring-red-600 border-red-300'
                  : 'focus:ring-2 focus:ring-[var(--primary)] border-gray-300'
              "
              required
              class="w-full px-4 py-3 pr-12 rounded-xl border focus:outline-none"
            />

            <!-- Angular FontAwesome Icon -->
            <fa-icon
              [icon]="hidePassword ? faEye : faEyeSlash"
              (click)="hidePassword = !hidePassword"
              class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-[var(--primary)] transition"
            ></fa-icon>
          </div>
          <div class="text-sm grid grid-cols-2 md:grid-cols-3 gap-4">
            <!-- Row 1: Lowercase & Uppercase -->
            <div
              class="flex items-center gap-2"
              [class.text-green-600]="password?.value?.match('(?=.*[a-z])')"
              [class.text-gray-400]="!password?.value?.match('(?=.*[a-z])')"
            >
              <span>{{
                password?.value?.match("(?=.*[a-z])") ? "✔" : "✖"
              }}</span>
              <span>Lowercase letter</span>
            </div>

            <div
              class="flex items-center gap-2"
              [class.text-green-600]="password?.value?.match('(?=.*[A-Z])')"
              [class.text-gray-400]="!password?.value?.match('(?=.*[A-Z])')"
            >
              <span>{{
                password?.value?.match("(?=.*[A-Z])") ? "✔" : "✖"
              }}</span>
              <span>Uppercase letter</span>
            </div>

            <!-- Row 2: Number & Special char -->
            <div
              class="flex items-center gap-2"
              [class.text-green-600]="password?.value?.match('(?=.*[0-9])')"
              [class.text-gray-400]="!password?.value?.match('(?=.*[0-9])')"
            >
              <span>{{
                password?.value?.match("(?=.*[0-9])") ? "✔" : "✖"
              }}</span>
              <span>Number</span>
            </div>

            <div
              class="flex items-center gap-2"
              [class.text-green-600]="password?.value?.match('(?=.*[@$!%*?&])')"
              [class.text-gray-400]="!password?.value?.match('(?=.*[@$!%*?&])')"
            >
              <span>{{
                password?.value?.match("(?=.*[@$!%*?&])") ? "✔" : "✖"
              }}</span>
              <span>Special character</span>
            </div>

            <!-- Row 3: Length (can span two columns) -->
            <div
              class="flex items-center gap-2 col-span-2"
              [class.text-green-600]="password?.value?.length >= 8"
              [class.text-gray-400]="password?.value?.length < 8"
            >
              <span>{{ password?.value?.length >= 8 ? "✔" : "✖" }}</span>
              <span>Minimum 8 characters</span>
            </div>
          </div>
          <div class="relative w-full">
            <input
              [type]="hideConfirmPassword ? 'password' : 'text'"
              placeholder="Confirm Password"
              formControlName="confirmPassword"
              name="confirmPassword"
              required
              [class]="
                signUpForm.get('confirmPassword')?.touched &&
                signUpForm.get('confirmPassword')?.invalid
                  ? 'focus:ring-2 focus:ring-red-600 border-red-300'
                  : 'focus:ring-2 focus:ring-[var(--primary)] border-gray-300'
              "
              class="w-full px-4 py-3 pr-12 rounded-xl border focus:outline-none"
            />

            <!-- FontAwesome Icon -->
            <fa-icon
              [icon]="hideConfirmPassword ? faEye : faEyeSlash"
              (click)="hideConfirmPassword = !hideConfirmPassword"
              class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-[var(--primary)] transition"
            ></fa-icon>
          </div>

          <button
            type="submit"
            [disabled]="signUpForm.invalid"
            class="w-full cursor-pointer flex items-center justify-center gap-1 py-3 rounded-xl font-semibold border transition bg-[var(--primary)] text-white border-[var(--primary)]  disabled:bg-gray-400 disabled:text-gray-200 disabled:border-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-400 disabled:hover:text-gray-200"
          >
            @if (loading) {
              <svg
                class="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
              Loading...
            } @else {
              Sign Up
            }
          </button>

          <button
            (click)="signUpWithGoogle()"
            type="button"
            class="mt-6 w-full flex justify-center items-center gap-3 py-3 border border-gray-300 rounded-xl hover:bg-gray-200 transition cursor-pointer"
          >
            <img src="./google.png" alt="Google logo" class="w-6 h-6" />
            <span class="text-gray-700 font-semibold">Sign up with Google</span>
          </button>
        </form>

        <p class="mt-6 text-gray-700">
          Already have an account?
          <a
            routerLink="/sign-in"
            class="text-[var(--primary)] font-semibold hover:underline cursor-pointer"
            >Sign In</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
